export function openModal(el) {
    setTimeout(() => {
        $.magnificPopup.open({
            items: {
                src: $(el),
            },
            type: 'inline',
            fixedContentPos: false,
            fixedBgPos: true,
            overflowY: 'auto',
            closeBtnInside: true,
            preloader: false,
            midClick: true,
            removalDelay: 300,
            mainClass: 'mfp-with-zoom',
        });
    }, 300)
}

$('.custom-close__magnific').on( "click", function() {
  $.magnificPopup.close();
});